// extracted by mini-css-extract-plugin
module.exports = {"slider":"bonus_slider-module_slider_7b696","icon":"bonus_slider-module_icon_0d17e"};